export default __webpack_public_path__ + "media/images/features/local_delivery/person_phone-d3128e75aac6ba45d47c08f8f406187e.png";